import { Injectable } from '@angular/core';
var DomController = /** @class */ (function () {
    function DomController() {
    }
    DomController.prototype.read = function (cb) {
        getQueue().read(cb);
    };
    DomController.prototype.write = function (cb) {
        getQueue().write(cb);
    };
    DomController.decorators = [
        { type: Injectable },
    ];
    return DomController;
}());
export { DomController };
function getQueue() {
    var Ionic = window.Ionic;
    if (Ionic && Ionic.queue) {
        return Ionic.queue;
    }
    return {
        read: function (cb) { return window.requestAnimationFrame(cb); },
        write: function (cb) { return window.requestAnimationFrame(cb); }
    };
}
